import { Form, TextField } from '@frontend/mui'
import { Button, Paper, Stack, Typography } from '@mui/material'
import { PropsWithChildren, useEffect } from 'react'
import profile from 'src/assets/profile.svg'
import profileBG from 'src/assets/profile_bg.svg'
import { isMobile } from 'src/utils/chaos'
import { useIntl } from '@frontend/t7nd'

export const ProfileMessages = {
  WELCOME: {
    id: '欢迎使用',
    defaultMessage: '欢迎使用',
  },
  WELCOME_TO_ASSET: {
    id: '欢迎来到 设备资产管理',
    defaultMessage: '欢迎来到 设备资产管理',
  },
  COMPLETE_INFO: {
    id: '请补充资料，以便后续使用',
    defaultMessage: '请补充资料，以便后续使用',
  },
  NAME: {
    id: '姓名',
    defaultMessage: '姓名',
  },
  ENTER_REAL_NAME: {
    id: '请输入真实姓名',
    defaultMessage: '请输入真实姓名',
  },
  CONFIRM: {
    id: '确定',
    defaultMessage: '确定',
  },
} as const

export function Container(props: PropsWithChildren<{}>) {
  return isMobile() ? (
    <Stack
      sx={{
        width: '100vw',
        height: '100vh',
        background: `url(${profileBG})`,
        backgroundPosition: 'right bottom',
        backgroundRepeat: 'no-repeat',
      }}
    >
      {props.children}
    </Stack>
  ) : (
    <Paper>
      <Stack
        sx={{
          width: 500,
          height: 560,
          background: `url(${profileBG})`,
          backgroundPosition: 'right bottom',
          backgroundRepeat: 'no-repeat',
        }}
      >
        {props.children}
      </Stack>
    </Paper>
  )
}

export function AddProfilePage() {
  const { formatMessage } = useIntl()
  useEffect(() => {
    const title = document.title
    setTimeout(() => (document.title = formatMessage(ProfileMessages.WELCOME)))
    return () => {
      document.title = title
    }
  }, [formatMessage])

  return (
    <Stack
      width="100vw"
      height="100vh"
      justifyContent="center"
      alignItems="center"
      overflow="auto"
      bgcolor="white"
    >
      <Form
        onSubmit={(values) => {
          fetch('/api/v1/wecom/post_profile', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(values),
          }).then(() => (window.location.pathname = '/'))
        }}
      >
        <Container>
          <Stack height="100%" spacing={6} p="48px 36px">
            <Stack spacing={3}>
              <img
                src={profile}
                width={isMobile() ? 140 : 210}
                height={isMobile() ? 36 : 54}
                alt="welcome"
              />
              <Stack spacing={1}>
                <Typography variant="h4">
                  {formatMessage(ProfileMessages.WELCOME_TO_ASSET)}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {formatMessage(ProfileMessages.COMPLETE_INFO)}
                </Typography>
              </Stack>
            </Stack>
            <Stack flex={1} justifyContent="space-between" alignItems="center">
              <TextField
                name="name"
                label={formatMessage(ProfileMessages.NAME)}
                placeholder={formatMessage(ProfileMessages.ENTER_REAL_NAME)}
                required
              />
              <Button type="submit" sx={{ width: isMobile() ? '100%' : 240 }}>
                {formatMessage(ProfileMessages.CONFIRM)}
              </Button>
            </Stack>
          </Stack>
        </Container>
      </Form>
    </Stack>
  )
}
